// extracted by mini-css-extract-plugin
export default {"container":"Hs-z","heading":"Is-z","text":"Js-z","info":"Ks-z","link":"Ls-z","fullMaxWidth":"Ms-z"};